import {postRequest} from "../../../middlewares/api/actions";
import {getCheckImportedFileXmlSdmxObjectsUrl, getImportFileXmlSdmxObjects20Url} from "../../../constants/urls";

export const IMPORT_STRUCTURES_20_FILE_UPLOAD = 'IMPORT_STRUCTURES_20_FILE_UPLOAD';
export const IMPORT_STRUCTURES_20_SUBMIT = 'IMPORT_STRUCTURES_20_SUBMIT';
export const IMPORT_STRUCTURES_20_RESET = 'IMPORT_STRUCTURES_20_RESET';
export const IMPORT_STRUCTURES_20_REPORT_HIDE = 'IMPORT_STRUCTURES_20_REPORT_HIDE';
export const IMPORT_STRUCTURES_FORM_CHANGE = 'IMPORT_STRUCTURES_FORM_CHANGE';

export const changeImportStructuresForm = fields => ({
    type: IMPORT_STRUCTURES_FORM_CHANGE,
    fields
  });

export const uploadImportStructures20File = file => {
  let fileFormData = new FormData();
  fileFormData.append('file', file);
  return postRequest(
    IMPORT_STRUCTURES_20_FILE_UPLOAD,
    getCheckImportedFileXmlSdmxObjectsUrl(),
    fileFormData,
    t => ({
      success: t('scenes.utilities.importStructures.messages.fileUpload.success')
    })
  );
};

export const submitImportStructures20 = (structures, hash) => postRequest(
  IMPORT_STRUCTURES_20_SUBMIT,
  getImportFileXmlSdmxObjects20Url(),
  {
    importedItem: structures,
    hashImport: hash
  }
)

export const hideImportStructures20Report = () => ({
  type: IMPORT_STRUCTURES_20_REPORT_HIDE
})

export const resetImportStructures20 = () => ({
  type: IMPORT_STRUCTURES_20_RESET
})
